import React from 'react';
import Routes from './routes';
import Layout from "./components/layout";

function App() {
  return (
    <Layout>
        <Routes />
     </Layout>
  );
}

export default App;